"use client";

import { ErrorState } from "@/components/errorState/ErrorState";
import { RenderError } from "@/types/defs/errorState";

// Scopes an app-page crash to the content area — the sidebar shell above this boundary stays alive and navigable.
export default function ApplicationError({
  error,
  reset,
}: {
  error: RenderError;
  reset: () => void;
}) {
  return <ErrorState error={error} reset={reset} boundary="application" />;
}
